import styled from 'styled-components'

export const Style = styled.div`
  .bottom {
    margin-bottom: 20px;
  }
  @media screen and (min-width: 300px) and (max-width: 767px) {
    .container-why-massage {
      width: 100%;
    }
  }

  .page-line {
    text-align: center;

    div {
      background: linear-gradient(270deg, #ffd192 0%, #ff8e30 100%);
      width: 70px;
      height: 8px;
      border-radius: 8px;
      display: inline-block;
    }
  }
`
